import parentListStore from '@modules/parent/parent-list-store';
import parentViewStore from '@modules/parent/parent-view-store';
import parentImporterStore from '@modules/parent/parent-importer-store';
import parentFormStore from '@modules/parent/parent-form-store';
import parentDestroyStore from '@modules/parent/parent-destroy-store';

export default {
  namespaced: true,

  modules: {
    destroy: parentDestroyStore,
    form: parentFormStore,
    list: parentListStore,
    view: parentViewStore,
    importer: parentImporterStore,
  },
};
